"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentMgmtApiService = exports.ApplyDraftChangesResult = exports.Queue = void 0;
var content_api_error_1 = require("./errors/content-api.error");
var utils_1 = require("./utils");
var array_util_1 = require("./utils/array.util");
var init_axios_client_util_1 = require("./utils/init-axios-client.util");
var Queue;
(function (Queue) {
    Queue[Queue["LOW_PRIO"] = 0] = "LOW_PRIO";
    Queue[Queue["HIGH_PRIO"] = 1] = "HIGH_PRIO";
})(Queue = exports.Queue || (exports.Queue = {}));
var ApplyDraftChangesResult;
(function (ApplyDraftChangesResult) {
    ApplyDraftChangesResult[ApplyDraftChangesResult["NO_DRAFT_CHANGES_FOUND"] = 0] = "NO_DRAFT_CHANGES_FOUND";
    ApplyDraftChangesResult[ApplyDraftChangesResult["DRAFT_CHANGES_APPLIED"] = 1] = "DRAFT_CHANGES_APPLIED";
})(ApplyDraftChangesResult = exports.ApplyDraftChangesResult || (exports.ApplyDraftChangesResult = {}));
var ContentMgmtApiService = /** @class */ (function () {
    function ContentMgmtApiService(options) {
        this.endpoint = options.endpoint;
        this.authenticationProvider = options.authentication;
        this.defaultRequestTimeout = options.defaultRequestTimeout || 10000;
        this.defaultRequestHeaders = options.defaultRequestHeaders;
        this.axiosRequestClient = init_axios_client_util_1.initiateAxiosClient(options.endpoint, options.authentication, options.defaultRequestTimeout || 10000, options.defaultRequestHeaders);
    }
    ContentMgmtApiService.prototype.throwAppropriateError = function (customMessage, error) {
        var _a, _b, _c, _d;
        var statusCode = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status;
        var responseBody = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data;
        if ((_d = (_c = error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.errors) {
            throw new content_api_error_1.default(error, customMessage + ": " + JSON.stringify(error.response.data.errors), statusCode !== null && statusCode !== void 0 ? statusCode : -1, responseBody);
        }
        else if (statusCode) {
            throw new content_api_error_1.default(error, customMessage + ": " + error.message, statusCode, responseBody);
        }
        else {
            throw new Error(customMessage + ": " + error.message);
        }
    };
    ContentMgmtApiService.prototype.createResource = function (contentResource, queue, options) {
        return __awaiter(this, void 0, void 0, function () {
            var contentType, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(contentResource === null || contentResource === void 0 ? void 0 : contentResource.id) || !utils_1.parseResourceId(contentResource.id)) {
                            throw new Error("Invalid content resource id: " + contentResource.id);
                        }
                        contentType = utils_1.parseContentTypeFromResourceId(contentResource.id);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.axiosRequestClient(init_axios_client_util_1.extendAxiosConfigWithRequestOptionsForWrite({
                                method: 'post',
                                url: "v4/types/" + contentType + "/resources",
                                data: {
                                    data: contentResource,
                                },
                            }, queue, options))];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.throwAppropriateError("Error creating resource " + contentResource.id, error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ContentMgmtApiService.prototype.createManyResources = function (contentResources, queue, options) {
        return __awaiter(this, void 0, void 0, function () {
            var error_2, resourceIds;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.validateResourceIds(contentResources);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.axiosRequestClient(init_axios_client_util_1.extendAxiosConfigWithRequestOptionsForWrite({
                                method: 'post',
                                url: "v4/resources",
                                data: {
                                    data: contentResources,
                                },
                            }, queue, options))];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        resourceIds = contentResources.map(function (res) { return res.id; }).join(',');
                        this.throwAppropriateError("Error creating resources " + resourceIds, error_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ContentMgmtApiService.prototype.deleteResource = function (id, queue, options) {
        return __awaiter(this, void 0, void 0, function () {
            var contentType, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!id || !utils_1.parseResourceId(id)) {
                            throw new Error("Invalid content resource id: " + id);
                        }
                        contentType = utils_1.parseContentTypeFromResourceId(id);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.axiosRequestClient(init_axios_client_util_1.extendAxiosConfigWithRequestOptionsForWrite({
                                method: 'delete',
                                url: "v4/types/" + contentType + "/resources/" + id,
                            }, queue, options))];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        this.throwAppropriateError("Error deleting resource " + id, error_3);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ContentMgmtApiService.prototype.getManyResourcesById = function (ids, options) {
        return __awaiter(this, void 0, void 0, function () {
            var maxBatchSize, idBuckets, requestPromises, batchRequestResults, contentResourcesPerBatchRequest;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!ids) {
                            throw new Error("Invalid request. No content resource ids provided.");
                        }
                        maxBatchSize = (options === null || options === void 0 ? void 0 : options.maxBatchSize) || 100;
                        if (maxBatchSize > 100) {
                            throw new Error("Invalid request options. Only support batch sizes up to 100");
                        }
                        idBuckets = array_util_1.chunk(ids, maxBatchSize);
                        requestPromises = idBuckets.map(function (idBucket) { return _this.fetchBucket(idBucket, options); });
                        return [4 /*yield*/, Promise.all(requestPromises)];
                    case 1:
                        batchRequestResults = _a.sent();
                        contentResourcesPerBatchRequest = batchRequestResults.map(function (requestPromiseResult) { return requestPromiseResult.data.data; });
                        return [2 /*return*/, {
                                data: [].concat.apply([], contentResourcesPerBatchRequest).sort(function (a, b) { return ids.indexOf(a.id) - ids.indexOf(b.id); }),
                            }];
                }
            });
        });
    };
    ContentMgmtApiService.prototype.fetchBucket = function (idBucket, options) {
        return __awaiter(this, void 0, void 0, function () {
            var idList, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        idList = idBucket.map(function (id) { return ({
                            id: id,
                            type: utils_1.parseContentTypeFromResourceId(id),
                        }); });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.axiosRequestClient(init_axios_client_util_1.extendAxiosConfigWithRequestOptions({
                                method: 'post',
                                url: "v4/query",
                                params: {
                                    disableLinkGeneration: true,
                                },
                                data: {
                                    data: idList,
                                },
                            }, options))];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_4 = _a.sent();
                        this.throwAppropriateError("Error fetching ids " + idList.map(function (element) { return element.id; }), error_4);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ContentMgmtApiService.prototype.getResourceById = function (id, options) {
        return __awaiter(this, void 0, void 0, function () {
            var contentType, requestResults, requestData, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!id || !utils_1.parseResourceId(id)) {
                            throw new Error("Invalid content resource id: " + id);
                        }
                        contentType = utils_1.parseContentTypeFromResourceId(id);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.axiosRequestClient(init_axios_client_util_1.extendAxiosConfigWithRequestOptions({
                                method: 'get',
                                url: "v4/types/" + contentType + "/resources/" + id,
                                params: {
                                    disableLinkGeneration: true,
                                },
                            }, options))];
                    case 2:
                        requestResults = _a.sent();
                        requestData = requestResults.data.data;
                        return [2 /*return*/, requestData];
                    case 3:
                        error_5 = _a.sent();
                        this.throwAppropriateError("Error fetching resource " + id, error_5);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ContentMgmtApiService.prototype.getResourceByIdWithIncludedRelationships = function (id, options) {
        return __awaiter(this, void 0, void 0, function () {
            var contentType, axiosConfig, data, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!id || !utils_1.parseResourceId(id)) {
                            throw new Error("Invalid content resource id: " + id);
                        }
                        if (!(options === null || options === void 0 ? void 0 : options.include)) {
                            throw new Error("Include parameter is required when fetching resource with included resources");
                        }
                        contentType = utils_1.parseContentTypeFromResourceId(id);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        axiosConfig = init_axios_client_util_1.extendAxiosConfigWithRequestOptions({
                            method: 'get',
                            url: "v4/types/" + contentType + "/resources/" + id,
                            params: {
                                disableLinkGeneration: true,
                            },
                        }, options);
                        return [4 /*yield*/, this.axiosRequestClient(axiosConfig)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                    case 3:
                        error_6 = _a.sent();
                        this.throwAppropriateError("Error fetching resource " + id, error_6);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ContentMgmtApiService.prototype.getResourceByIdAtTimestamp = function (id, timestamp, options) {
        return __awaiter(this, void 0, void 0, function () {
            var requestResults, requestData, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!id || !utils_1.parseResourceId(id)) {
                            throw new Error("Invalid content resource id: " + id);
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.axiosRequestClient(init_axios_client_util_1.extendAxiosConfigWithRequestOptions({
                                method: 'post',
                                url: "v4/_documentAtTimestamp/" + id,
                                params: {
                                    time: timestamp,
                                },
                                headers: {
                                    'content-type': 'application/json',
                                },
                                data: {},
                            }, options))];
                    case 2:
                        requestResults = _a.sent();
                        requestData = requestResults.data.data;
                        return [2 /*return*/, requestData];
                    case 3:
                        error_7 = _a.sent();
                        this.throwAppropriateError("Error fetching resource " + id + " at timestamp: " + timestamp, error_7);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ContentMgmtApiService.prototype.getResourcesByNextLink = function (nextLink, options) {
        return __awaiter(this, void 0, void 0, function () {
            var requestResults, requestData, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!nextLink) {
                            throw new Error("Invalid request. No nextLink provided");
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.axiosRequestClient(init_axios_client_util_1.extendAxiosConfigWithRequestOptions({
                                method: 'get',
                                url: nextLink,
                                params: {
                                    disableLinkGeneration: true,
                                },
                            }, options))];
                    case 2:
                        requestResults = _a.sent();
                        requestData = requestResults.data;
                        return [2 /*return*/, requestData];
                    case 3:
                        error_8 = _a.sent();
                        this.throwAppropriateError("Error fetching resource by next link " + nextLink, error_8);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ContentMgmtApiService.prototype.getBestMatchingLocalizedResourceForMaster = function (masterId, localeMixingStrategy, requestOptions) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var contentType, localeMixingStrategyCommaSeparated, options, requestResults, response, included, includedCount, error_9;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!masterId.startsWith('rrn:content:')) {
                            throw new Error('the specified content id is not a master resource id: ' + masterId);
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        contentType = utils_1.parseContentTypeFromResourceId(masterId);
                        if (!contentType.startsWith('rrn:master:')) {
                            throw new Error('the specified content id is not a master resource id: ' + masterId);
                        }
                        if (((_a = localeMixingStrategy === null || localeMixingStrategy === void 0 ? void 0 : localeMixingStrategy.length) !== null && _a !== void 0 ? _a : 0) === 0) {
                            throw new Error('invalid locale mixing strategy for master ' + masterId);
                        }
                        localeMixingStrategyCommaSeparated = localeMixingStrategy.join(',');
                        options = init_axios_client_util_1.extendAxiosConfigWithRequestOptionsForHeadersOnly({
                            method: 'get',
                            url: "v4/types/" + contentType + "/resources/" + masterId,
                            params: {
                                disableLinkGeneration: true,
                                include: "translations(dedup:" + localeMixingStrategyCommaSeparated + ")",
                            },
                        }, requestOptions);
                        return [4 /*yield*/, this.axiosRequestClient(options)];
                    case 2:
                        requestResults = _c.sent();
                        response = requestResults.data;
                        included = response.included;
                        includedCount = (_b = included === null || included === void 0 ? void 0 : included.length) !== null && _b !== void 0 ? _b : 0;
                        if (includedCount > 1) {
                            throw new Error("unexpected number of included resources, please check with the content api team, expected 1, but got " + included.length);
                        }
                        else if (includedCount === 1) {
                            return [2 /*return*/, included[0]];
                        }
                        return [2 /*return*/, undefined];
                    case 3:
                        error_9 = _c.sent();
                        this.throwAppropriateError("Error fetching resource " + masterId, error_9);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ContentMgmtApiService.prototype.patchResource = function (resourcePatch, queue, options) {
        return __awaiter(this, void 0, void 0, function () {
            var contentType, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(resourcePatch === null || resourcePatch === void 0 ? void 0 : resourcePatch.id) || !utils_1.parseResourceId(resourcePatch.id)) {
                            throw new Error("Invalid content resource id: " + resourcePatch.id);
                        }
                        contentType = utils_1.parseContentTypeFromResourceId(resourcePatch.id);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.axiosRequestClient(init_axios_client_util_1.extendAxiosConfigWithRequestOptionsForWrite({
                                method: 'patch',
                                url: "v4/types/" + contentType + "/resources/" + resourcePatch.id,
                                data: {
                                    data: resourcePatch,
                                },
                            }, queue, options))];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_10 = _a.sent();
                        this.throwAppropriateError("Error patching resource " + resourcePatch.id, error_10);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ContentMgmtApiService.prototype.patchManyResources = function (resourcePatches, queue, options) {
        return __awaiter(this, void 0, void 0, function () {
            var error_11, resourceIds;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.validateResourceIds(resourcePatches);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.axiosRequestClient(init_axios_client_util_1.extendAxiosConfigWithRequestOptionsForWrite({
                                method: 'patch',
                                url: "v4/resources",
                                data: {
                                    data: resourcePatches,
                                },
                            }, queue, options))];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_11 = _a.sent();
                        resourceIds = resourcePatches.map(function (res) { return res.id; }).join(',');
                        this.throwAppropriateError("Error patching resources " + resourceIds, error_11);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ContentMgmtApiService.prototype.upsertResource = function (contentResource, queue, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateResource(contentResource, queue, options)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, true];
                }
            });
        });
    };
    ContentMgmtApiService.prototype.updateResource = function (contentResource, queue, options) {
        return __awaiter(this, void 0, void 0, function () {
            var contentType, error_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(contentResource === null || contentResource === void 0 ? void 0 : contentResource.id) || !utils_1.parseResourceId(contentResource.id)) {
                            throw new Error("Invalid content resource id: " + contentResource.id);
                        }
                        contentType = utils_1.parseContentTypeFromResourceId(contentResource.id);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.axiosRequestClient(init_axios_client_util_1.extendAxiosConfigWithRequestOptionsForWrite({
                                method: 'put',
                                url: "v4/types/" + contentType + "/resources/" + contentResource.id,
                                data: {
                                    data: contentResource,
                                },
                            }, queue, options))];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_12 = _a.sent();
                        this.throwAppropriateError("Error updating resource " + contentResource.id, error_12);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ContentMgmtApiService.prototype.getTranslationsForMaster = function (id, options) {
        return __awaiter(this, void 0, void 0, function () {
            var contentType, requestResults, error_13;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!id || !utils_1.isMasterContentResourceId(id)) {
                            throw new Error("Invalid master resource id: " + id);
                        }
                        contentType = utils_1.parseContentTypeFromResourceId(id);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.axiosRequestClient(init_axios_client_util_1.extendAxiosConfigWithRequestOptions({
                                method: 'get',
                                url: "v4/types/" + contentType + "/resources/" + id + "/relationships/translations",
                                params: {
                                    disableLinkGeneration: true,
                                },
                            }, options))];
                    case 2:
                        requestResults = _a.sent();
                        return [2 /*return*/, requestResults.data];
                    case 3:
                        error_13 = _a.sent();
                        this.throwAppropriateError("Error fetching translations for master " + id, error_13);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ContentMgmtApiService.prototype.applyDraftChanges = function (id, options) {
        return __awaiter(this, void 0, void 0, function () {
            var contentType, status, error_14;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!id || !utils_1.parseResourceId(id)) {
                            throw new Error("Invalid content resource id: " + id);
                        }
                        contentType = utils_1.parseContentTypeFromResourceId(id);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.axiosRequestClient(init_axios_client_util_1.extendAxiosConfigWithRequestOptions({
                                method: 'put',
                                url: "v4/types/" + contentType + "/resources/" + id + "/applyDraftChanges",
                                headers: {
                                    'content-type': 'application/json',
                                },
                                data: {},
                            }, options))];
                    case 2:
                        status = (_a.sent()).status;
                        return [2 /*return*/, status === 202 ? ApplyDraftChangesResult.DRAFT_CHANGES_APPLIED : ApplyDraftChangesResult.NO_DRAFT_CHANGES_FOUND];
                    case 3:
                        error_14 = _a.sent();
                        this.throwAppropriateError("Error applying draft changes to resource " + id, error_14);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ContentMgmtApiService.prototype.validateResourceIds = function (resourcePatches) {
        if (!resourcePatches) {
            throw new Error("no resources provided");
        }
        var incorrectResourceIds = [];
        resourcePatches.forEach(function (contentResource) {
            var _a, _b;
            try {
                if (!(contentResource === null || contentResource === void 0 ? void 0 : contentResource.id) || !utils_1.parseResourceId(contentResource.id)) {
                    incorrectResourceIds.push((_a = contentResource === null || contentResource === void 0 ? void 0 : contentResource.id) !== null && _a !== void 0 ? _a : 'no id given');
                }
            }
            catch (e) {
                incorrectResourceIds.push((_b = contentResource === null || contentResource === void 0 ? void 0 : contentResource.id) !== null && _b !== void 0 ? _b : 'no id given');
            }
        });
        if (incorrectResourceIds.length > 0) {
            throw new Error("Invalid content resource ids: " + incorrectResourceIds.join(','));
        }
    };
    return ContentMgmtApiService;
}());
exports.ContentMgmtApiService = ContentMgmtApiService;
//# sourceMappingURL=content-mgmt-api.service.js.map